/* Flowers Alley home page: live same-day cut-off and suburb delivery checker (1 Nov 2026).
   Rules (from the site FAQ): same day when ordered by 12pm Mon-Fri or 9am Sat, Melbourne time; no delivery Sundays or
   Victorian public holidays. Update HOLIDAYS each year. */
(function () {
  var HOLIDAYS = ["2026-11-03", "2026-12-25", "2026-12-26", "2026-12-28", "2027-01-01", "2027-01-26", "2027-03-08", "2027-03-26",
    "2027-03-27", "2027-03-28", "2027-03-29", "2027-04-25", "2027-06-14", "2027-11-02", "2027-12-25", "2027-12-27", "2027-12-28"];
  var DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  function mel(d) {
    var p = {}; new Intl.DateTimeFormat("en-AU", { timeZone: "Australia/Melbourne", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false })
      .formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
    var y = +p.year, m = +p.month, dd = +p.day, wd = new Date(Date.UTC(y, m - 1, dd)).getUTCDay();
    return { y: y, m: m, d: dd, h: +p.hour % 24, mi: +p.minute, wd: wd, key: p.year + "-" + p.month + "-" + p.day };
  }
  function shift(t, n) { var u = new Date(Date.UTC(t.y, t.m - 1, t.d + n)); var k = u.toISOString().slice(0, 10); return { wd: u.getUTCDay(), key: k }; }
  function deliverable(wd, key) { return wd !== 0 && HOLIDAYS.indexOf(key) < 0; }
  function cutoffText() {
    var t = mel(new Date()), cut = t.wd === 6 ? 9 : 12;
    if (deliverable(t.wd, t.key)) {
      var left = cut * 60 - (t.h * 60 + t.mi);
      if (left > 0) {
        var h = Math.floor(left / 60), m = left % 60;
        return "Order in the next " + (h ? h + " h " : "") + m + " min for delivery today";
      }
    }
    for (var i = 1; i < 10; i++) {
      var n = shift(t, i);
      if (deliverable(n.wd, n.key)) return "Order now for delivery " + (i === 1 ? "tomorrow" : DAYS[n.wd]);
    }
    return "Same day delivery · Order by 12pm Mon–Fri or 9am Sat";
  }
  /* suburb + hospital pages: the hero eyebrow shows the live cut-off too (James 2 Nov) */
  document.querySelectorAll(".fa-suburb .fa-hero .fa-eyebrow").forEach(function (el) { el.setAttribute("data-fa-cutoff", ""); });
  function tick() { document.querySelectorAll("[data-fa-cutoff]").forEach(function (el) { el.textContent = cutoffText(); }); }
  tick(); setInterval(tick, 30000);

  /* suburb checker */
  var list = null;
  function load(url, cb) { if (list) return cb(list); fetch(url).then(function (r) { return r.json(); }).then(function (j) { list = j; cb(j); }).catch(function () { cb([]); }); }
  function norm(s) { return (s || "").toLowerCase().replace(/[^a-z0-9 ]/g, "").replace(/\s+/g, " ").trim(); }
  function find(q, j) {
    q = norm(q); if (!q) return null;
    var pc = q.match(/\b3\d{3}\b/);
    if (pc) { var byPc = j.filter(function (x) { return x.p.indexOf(pc[0]) >= 0; }); if (byPc.length) return byPc; }
    var name = q.replace(/\b\d{4}\b/, "").trim();
    var exact = j.filter(function (x) { return norm(x.n) === name; }); if (exact.length) return exact;
    var start = j.filter(function (x) { return norm(x.n).indexOf(name) === 0; }); return start.length ? start.slice(0, 3) : null;
  }
  document.querySelectorAll("[data-fa-check]").forEach(function (form) {
    var input = form.querySelector("input");
    if (window.matchMedia("(max-width:749px)").matches && input.getAttribute("data-ph-short")) input.placeholder = input.getAttribute("data-ph-short");
    var out = document.getElementById(form.getAttribute("data-fa-check")), dl = document.getElementById(input.getAttribute("list"));
    input.addEventListener("focus", function () {
      load(form.getAttribute("data-src"), function (j) {
        if (dl && !dl.childElementCount) j.forEach(function (x) { var o = document.createElement("option"); o.value = x.n + (x.p[0] ? " " + x.p[0] : ""); dl.appendChild(o); });
      });
    }, { once: true });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      load(form.getAttribute("data-src"), function (j) {
        var r = find(input.value, j), cut = cutoffText();
        if (r && r.length) {
          var s = r[0];
          out.innerHTML = "Yes, we deliver to <strong>" + s.n + "</strong>. " + cut + ".";  /* no suburb-page link until those pages are finished (James 2 Nov) */
          /* tag the cart so orders show the checker was used (James 2 Nov): Additional details → "Delivery checker" */
          try { fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { "Delivery checker": s.n + (s.p[0] ? " " + s.p[0] : "") } }) }).catch(function () {}); } catch (e) {}
          /* count every check in Google Analytics, ordered or not (James 3 Nov) */
          try { window.gtag && gtag("event", "fa_delivery_check", { result: "delivered", suburb: s.n, postcode: s.p[0] || "", same_day_text: cut }); } catch (e) {}
        } else if (input.value.trim()) {
          out.innerHTML = 'We couldn\'t find that suburb. Call us on <a href="tel:0359857040">(03) 5985 7040</a> and we\'ll check for you.';
          try { window.gtag && gtag("event", "fa_delivery_check", { result: "not_found", query: input.value.trim().slice(0, 40) }); } catch (e) {}
        }
      });
    });
  });
})();
